import { IinitialNotificationState } from "./interfaces";

export const NotificationReducer = (
  state: IinitialNotificationState,
  action: any
) => {
  switch (action.type) {
    case "show_delete":
      let payload = action.payload;
      document.body.classList[payload.status ? "add" : "remove"](
        "h-screen",
        "overflow-hidden"
      );
      return { ...state, showDelete: payload };
    case "show_filter":
      let showFilter = state.showFilter;
      document.body.classList[!showFilter ? "add" : "remove"](
        "h-screen",
        "overflow-hidden"
      );
      return { ...state, showFilter: !showFilter };
    case "handle_chip":
      let new_chip = action.payload;
      return { ...state, chip: new_chip };
  }
};
